<template>
  <div id="topbar">
    <div></div>
    <b-container>
      <b-row>
        <b-col>
          <div class="topbar_title_container">
            <h1 id="title_topbar">
              <span class="inner_title_topbar">{{ $store.state.module.nom }}</span>
            </h1>

            <h2 id="subtitle_topbar">
              <span class="inner_subtitle_topbar">{{ readable_date }}</span>
            </h2>
            <h2 v-if="$store.state.logged" id="subtitle_topbar">
              <span class="inner_subtitle_topbar">Interface PC Course</span>
            </h2>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col>
          <Navigation></Navigation>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import moment from "moment";
export default {
  components: { Navigation },
  computed: {
    readable_date() {
      moment.locale("fr");
      let start = moment(this.$store.state.module.date_course, "DD-MM-YYYY").format("DD MMMM YYYY");
      let end = moment(this.$store.state.module.date_course_fin, "DD-MM-YYYY").format("DD MMMM YYYY");
      return start + " - " + end;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>